import { gsap } from 'gsap'
import { clamp, lerp } from '@mockly/animation-utils'
import { SplitText } from 'gsap/SplitText'

const selectors = {
  content: '[data-content]',
  text: '[data-text]',
  textClone: '[data-text-clone]',
}

class ScalingMediaText extends HTMLElement {
  #container = null;
  #splitText = null;
  #textClone = null;
  #content = null;
  #rafLoop = null;
  #progress = 0;
  #targetProgress = 0;

  constructor() {
    super();

    gsap.registerPlugin(SplitText)
    
    this.animate = this.animate.bind(this)
  }

  animate() {
    const rect = this.#container.getBoundingClientRect()

    const offsetY = -1 * (rect.top - window.innerHeight)
    
    this.#targetProgress = clamp(offsetY / window.innerHeight, 0, 1)

    if ((this.#progress > 0 || this.#progress < 1) && !(this.#progress === this.#targetProgress)) {
      this.#progress = lerp(this.#progress, this.#targetProgress, 0.065)
      this.style.setProperty('--progress', this.#progress)
      this.style.setProperty('--opacity-progress', (this.#progress - 0.5) * 2)
    }

    this.#rafLoop = requestAnimationFrame(this.animate)
  }

  setupWordReveal() {
    if (!this.#textClone) return

    this.#splitText = SplitText.create(this.#textClone, {
      type: 'words',
      wordsClass: 'scaling-media-text__word'
    })

    const wordCount = this.#splitText.words?.length ?? 0

    this.#splitText.words?.forEach((word, index) => {
      const wordProgress = index / wordCount
      
      word.style.setProperty('--word-progress', wordProgress)
    })
  }

  init() {
    this.setupWordReveal()
    
    this.#rafLoop = requestAnimationFrame(this.animate)
  }

  connectedCallback() {
    this.#container = this
    this.#content = this.querySelector(selectors.content)
    this.#textClone = this.querySelector(selectors.textClone)

    this.init()
  }
}

if (!customElements.get('scaling-media-text')) {
  customElements.define('scaling-media-text', ScalingMediaText);
}